module.exports = __webpack_public_path__ + "img/voucher-logo.ec5f05c3.svg";